import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { TermsPageContent } from 'client/contents/TermsPageContent/TermsPageContent'

type TProps = {}

const TermsPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.TermsPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <TermsPageContent />
    </article>
  )
}

export default TermsPage
